import { useRef } from "react";
import "./style.css";
import { CSSTransition } from "react-transition-group";
import Slider from "../../../components/Slider";
import Switch from "../../../components/Switch";
import Divider from "../../../svgs/Divider";
import { FEATURE_KEYS, GENERATOR, STAIR_OPTIONS } from "../../../constants";
import SectionLabel from "../../../components/SectionLabel";
import Dropdown from "../../../components/Dropdown";

const AdvancedSettings = ({
  advancedSettingsRef,
  disabled,
  panelState,
  handleStairsChange,
  handlePartyLevelChange,
  handlePartyLevelBlur,
  handlePartySizeChange,
  handleDifficultyChange,
  handleSeedShow,
  handleSeedChange,
}) => {
  const customSeedRef = useRef(null);
  const stairsRef = useRef(null);
  const partyLevelRef = useRef(null);
  const partySizeRef = useRef(null);
  const difficultyRef = useRef(null);

  const showPartyLevel = panelState.generator === GENERATOR.DUNGEON;
  const showPartySize = panelState.generator === GENERATOR.DUNGEON;
  const showDifficulty = panelState.generator === GENERATOR.DUNGEON;
  const showStairsDropDown = panelState.generator === GENERATOR.DUNGEON;

  return (
    <div ref={advancedSettingsRef} className="sectionContainer">
      <Divider />

      <SectionLabel
        text="Advanced Settings"
        disabled={disabled}
        small
        featureKey={FEATURE_KEYS.ADVANCED_SETTINGS}
      />
      <div className="advancedSectionContainer">
        <label
          className={`label 
            ${disabled && "disabledColorText"}`}
        >
          Custom Seed
        </label>
        <div style={{ marginTop: 4 }}>
          <Switch
            checked={panelState.advancedSettings.seed.show}
            onChange={handleSeedShow}
            disabled={disabled}
          />
        </div>
        <CSSTransition
          in={panelState.advancedSettings.seed.show}
          nodeRef={customSeedRef}
          timeout={200}
          classNames="fade"
          unmountOnExit
        >
          <input
            type="number"
            className="textField"
            style={{ width: "80%" }}
            placeholder="e.g. 1428317263"
            value={panelState.advancedSettings.seed.value || ""}
            onChange={(e) => handleSeedChange(e.target.value)}
            ref={customSeedRef}
          />
        </CSSTransition>
      </div>
      <CSSTransition
        in={showStairsDropDown}
        nodeRef={stairsRef}
        timeout={200}
        classNames="fade"
        unmountOnExit
      >
        <div className="advancedSectionContainer" ref={stairsRef}>
          <label
            className={`label 
            ${disabled && "disabledColorText"}`}
          >
            Stairs
          </label>
          <Dropdown
            options={STAIR_OPTIONS}
            optionLabels={STAIR_OPTIONS.map(
              (option) => option.charAt(0).toUpperCase() + option.slice(1)
            )}
            value={panelState.advancedSettings.stairs}
            onChange={handleStairsChange}
            disabled={disabled}
            featureKey={FEATURE_KEYS.ADVANCED_SETTINGS}
          />
        </div>
      </CSSTransition>
      <CSSTransition
        in={showPartyLevel}
        nodeRef={partyLevelRef}
        timeout={200}
        classNames="fade"
        unmountOnExit
      >
        <div className="advancedSectionContainer" ref={partyLevelRef}>
          <label
            className={`label 
            ${disabled && "disabledColorText"}`}
          >
            Party Level
          </label>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Slider
              min={1}
              max={20}
              step={1}
              ticks={[1, 20]}
              value={panelState.advancedSettings.partyLevel}
              onChange={handlePartyLevelChange}
              disabled={disabled}
            />
            <input
              type="number"
              min={1}
              max={20}
              value={panelState.advancedSettings.partyLevel}
              onChange={(e) => handlePartyLevelChange(Number(e.target.value))}
              onBlur={handlePartyLevelBlur}
              disabled={disabled}
              style={{
                height: 20,
                width: 20,
                marginLeft: 20,
                marginTop: 5,
              }}
              className="no-arrows"
            />
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={showPartySize}
        nodeRef={partySizeRef}
        timeout={200}
        classNames="fade"
        unmountOnExit
      >
        <div className="advancedSectionContainer" ref={partySizeRef}>
          <label
            className={`label 
            ${disabled && "disabledColorText"}`}
          >
            Party Size
          </label>
          <Slider
            min={1}
            max={5}
            step={1}
            ticks={[1, 2, 3, 4, 5]}
            value={panelState.advancedSettings.partySize}
            onChange={handlePartySizeChange}
            disabled={disabled}
          />
        </div>
      </CSSTransition>
      <CSSTransition
        in={showDifficulty}
        nodeRef={difficultyRef}
        timeout={200}
        classNames="fade"
        unmountOnExit
      >
        <div className="advancedSectionContainer" ref={difficultyRef}>
          <label
            className={`label 
            ${disabled && "disabledColorText"}`}
          >
            Difficulty
          </label>
          <div className="difficultyButtonContainer">
            <div
              className={`${
                panelState.advancedSettings.difficulty === "easy"
                  ? "wideButtonActive"
                  : "wideButton"
              } ${
                disabled
                  ? panelState.advancedSettings.difficulty === "easy"
                    ? "disabledDefaultWideButton"
                    : "disabledWideButton"
                  : ""
              } selectNone`}
              onClick={() => !disabled && handleDifficultyChange("easy")}
            >
              Easy
            </div>
            <div
              className={` ${
                panelState.advancedSettings.difficulty === "medium"
                  ? "wideButtonActive"
                  : "wideButton"
              } ${
                disabled
                  ? panelState.advancedSettings.difficulty === "medium"
                    ? "disabledDefaultWideButton"
                    : "disabledWideButton"
                  : ""
              } selectNone`}
              onClick={() => !disabled && handleDifficultyChange("medium")}
            >
              Medium
            </div>
            <div
              className={`${
                panelState.advancedSettings.difficulty === "hard"
                  ? "wideButtonActive"
                  : "wideButton"
              } ${
                disabled
                  ? panelState.advancedSettings.difficulty === "hard"
                    ? "disabledDefaultWideButton"
                    : "disabledWideButton"
                  : ""
              } selectNone`}
              onClick={() => !disabled && handleDifficultyChange("hard")}
            >
              Hard
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default AdvancedSettings;
